import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import PolicyAuthComponent from './PolicyAuthComponent';
import { getPartners } from '../../actions/partners';
import MoreDetails from './MoreDetails';
import CouponComponent from './CouponComponent';
import Loading from './Loading';
import { Products } from '../../actions/types';

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}));

const Home = () => {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);

  const partner = urlParams.get('partner') ?? 'N/A';

  const [component, setComponent] = useState('policyNumber');
  const [company, setCompany] = useState();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    async function getPartnersAsync(partner, id) {
      try {
        const res = await getPartners(partner, id);
        const { status, data } = res;
        if (status === 200 && JSON.stringify(data)) {
          console.log(data);
          setCompany(data);
        } else {
          throw new Error('Unable to retrieve partners');
        }
      } catch (error) {
        console.log(error.message);
        setComponent('moreDetails');
      } finally {
        setIsLoading(false);
      }
    }

    if (partner) {
      getPartnersAsync(partner);
    } else {
      setComponent('moreDetails');
      setIsLoading(false);
    }
  }, []);

  const handleCallback = async (isEligible) => {
    
    isEligible ? setComponent('coupon') : setComponent('moreDetails');
  };

  const classes = useStyles();

  return (
    <Container component='main' maxWidth='md'>
      <div className={classes.paper}>
        {isLoading && <Loading />}
        {component === 'policyNumber' && !isLoading && (
          <>
            <PolicyAuthComponent
              partner={partner}
              company={company}
              callback={handleCallback}
            />
          </>
        )}
        {component === 'moreDetails' && (
          <>
            <MoreDetails />
          </>
        )}
        {component === 'coupon' && <CouponComponent company={company} />}
      </div>
    </Container>
  );
};

export default Home;
